module.exports = __webpack_public_path__ + "img/car-A.63877e75.jpg";